
import React from "react";
import { Link } from "react-router-dom";
import "./Header.css";

function Header() {
  return (
    <div className="container">
      <div className="link-cont">
        <Link className="links" to='/'>home</Link>
        <Link className="links" to='projects'>Projects</Link>
      </div>
    </div>
  ); 
}

export default Header;
